<div class="toast-container">
    <div *ngIf="toast" class="toast" [ngClass]="toastClass(toast)">
      <svg-icon [svgStyle]="{ 'width.rem': '2' }" class="icon" [src]="'../../../assets/img/icons/' + (toast.icon ? toast.icon : 'alert.svg')"></svg-icon>
      <span class="message">{{ toast.message }}</span>
      <span class="close" (click)="close()">&times;</span>
    </div>
  </div>